import { createStore } from 'vuex'


const store = createStore({
    state () {
        return {
            username: '',
            userid: '',
            role: '',
            company: ''
        }
    },
    mutations: {
        setusername (state, username) {
            state.username = username;
        },
        setuserid(state, userid) {
            state.userid = userid;
        },
        setrole(state, role) {
            state.role = role;
        },
        setcompany(state, company) {
            state.company = company;
        }
    }
});

export default store;
